export default __webpack_public_path__ + "2017 Dark Vibronic Polaritons and the Spectroscopy of Organic Microcavities.pdf";